import React from "react";
import "./primary-button.styles.scss";

type PrimaryButtonProps = {
  children?: React.ReactNode;
  href?: string;
  large?: boolean;
  tiny?: boolean;
  color?: string;
  inverted?: boolean;
  padding?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  href,
  large,
  tiny,
  color,
  inverted,
  padding,
  ...otherProps
}) => {
  const renderButton = () => (
    <button
      className={`custom-button ${inverted ? "inverted" : ""} ${tiny ? "mobile" : null} ${large ? "large" : null}`}
      style={{
        backgroundColor: color || undefined,
        padding: padding || undefined,
      }}
      {...otherProps}
    >
      {children}
    </button>
  );

  return (
    <div>
      {href ? (
        <a
          className="link"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {renderButton()}
        </a>
      ) : (
        renderButton()
      )}
    </div>
  );
};

export default PrimaryButton;
